import { hollandStakingAddress, tokenAddress } from 'global';

const networkBaseUrl = process.env.REACT_APP_NETWORK_BASE_URL as string;

export const tokenContractLink = `${networkBaseUrl}/address/${tokenAddress}`;
export const stakingContractLink = `${networkBaseUrl}/address/${hollandStakingAddress}#code`;
